import React from 'react';
import ReactDOM from 'react-dom/client';

import Quiz from '@src/Quiz/Quiz';
import Video from '@src/Video/Video';

import '@fontsource/inter';
import './index.scss';
import Admin from './Admin/Admin';
import {SharedConfigProvider} from './Components/SharedConfigProvider';
import {SharedEventProvider} from './Components/SharedEventProvider';

const urlParams = new URLSearchParams(window.location.search);
const isVideo = urlParams.get('video') === 'true';
const isAdmin = urlParams.get('admin') === '15158';

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	<React.StrictMode>
		<SharedEventProvider>
			<SharedConfigProvider>
				{isVideo && <Video />}
				{isAdmin && <Admin />}
				{!isVideo && !isAdmin && <Quiz />}
			</SharedConfigProvider>
		</SharedEventProvider>
	</React.StrictMode>
);
